// off: no feature activity; drain: replay only; on: capture and replay.
export const offlineMode = ['on', 'drain'].includes(process.env.REACT_APP_OFFLINE_ACTIONS_MODE)
  ? process.env.REACT_APP_OFFLINE_ACTIONS_MODE : 'off';
const allowedDoctors = new Set((process.env.REACT_APP_OFFLINE_DOCTOR_IDS || '')
  .split(',').map(value => value.trim()).filter(Boolean));
export const offlineRuntimeEnabled = offlineMode !== 'off' && allowedDoctors.size > 0;
// Profile expansion has its own switch; enabling the original notes pilot must
// not accidentally activate new waiting-list, billing or attachment behavior.
export const profileOfflineEnabled = process.env.REACT_APP_OFFLINE_PROFILES_ENABLED === 'true';
export const canSyncDoctor = doctorId => typeof doctorId === 'string' && doctorId.length > 0
  && offlineRuntimeEnabled && (allowedDoctors.has('*') || allowedDoctors.has(doctorId));
export const canCaptureDoctor = doctorId => offlineMode === 'on' && canSyncDoctor(doctorId);
